import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    // Get stored payment info
    const pendingPayment = localStorage.getItem("pending_payment");

    if (pendingPayment) {
      try {
        const paymentInfo = JSON.parse(pendingPayment);
        setPaymentDetails(paymentInfo);
      } catch (e) {
        // Error parsing payment info
      }
    }

    // Clear pending payment from storage
    localStorage.removeItem("pending_payment");
  }, []);

  const getBillTypeName = (type) => {
    const names = {
      kelectric: "K-Electric Bill",
      ssgc: "SSGC Gas Bill",
      water: "Water Bill",
      maintainance: "Maintenance Charges",
      trash: "Trash Charges",
      rent: "Monthly Rent",
      advance: "Advance / Security Deposit",
    };
    return names[type] || type;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 500, width: "100%", textAlign: "center" }}>
        <CardContent sx={{ p: 4 }}>
          <CancelIcon sx={{ fontSize: 80, color: "#f44336", mb: 2 }} />
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 2 }}>
            Payment Cancelled
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your payment was cancelled. No amount was charged to your account.
          </Typography>

          {paymentDetails && (
            <Box
              sx={{
                bgcolor: "#fff3e0",
                p: 2,
                borderRadius: 2,
                mb: 3,
              }}
            >
              <Typography variant="subtitle2" color="text.secondary">
                Cancelled Payment
              </Typography>
              <Typography variant="body1" fontWeight="bold" sx={{ mb: 1 }}>
                {getBillTypeName(paymentDetails.billType)}
              </Typography>

              <Typography variant="subtitle2" color="text.secondary">
                Amount
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                PKR {parseFloat(paymentDetails.amount || 0).toLocaleString()}
              </Typography>
            </Box>
          )}

          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate("/tenant-dashboard")}
            >
              Go to Dashboard
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate(-1)}
            >
              Try Again
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

